import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as supportActions from "../../redux/actions/support";
import { Loading, Button } from "../../components/widgets/index";
import Page from "../../components/layout/Page";
import Permissions from "../../permissions";
import CommentList from "../../components/support/CommentList";
import CommentAdd from "../../components/support/CommentAdd";
import SupportIssueInfo from "../../components/support/SupportIssueInfo";
import "./SupportIssue.css";
import { Modal } from "../../components/layout/Modal";

const mapStateToProps = state => ({
  ticket: state.support.activeTicket,
});

const mapDispatchToProps = dispatch => {
  return {
    supportActions: bindActionCreators(supportActions, dispatch),
  };
};

class SupportIssue extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reply: false,
      showCancelModal: false,
      comment: "",
      errors: {},
    };
  }

  componentDidMount = () => {
    this.props.supportActions.fetchActiveZendeskTicket(this.props.match.params.id);
  };

  componentWillUnmount = () => {
    this.props.supportActions.clearActiveZendeskTicket();
    // this.props.supportActions.clearActiveTicketHistory();
  };

  handleFieldOnChange = value => {
    this.setState({
      comment: value,
    });
  };

  validateTicket = () => {
    let errors = {};
    if (!this.state.comment) {
      errors.comment = "You must enter a comment.";
    }

    return errors;
  };

  hasErrors = errors => {
    if (errors.comment) {
      return true;
    }

    return false;
  };

  handleOpenModal = () => {
    if (this.state.comment !== "") {
      this.setState({
        showCancelModal: true,
      });
    } else {
      this.setState({
        reply: false,
        errors: {},
      });
    }
  };

  handleCloseModal = () => {
    this.setState({
      showCancelModal: false,
    });
  };

  deleteComment = () => {
    this.setState({
      showCancelModal: false,
      comment: "",
      reply: false,
      errors: {},
    });
  };

  addComment = () => {
    this.setState({
      reply: true,
    });
  };

  submitComment = () => {
    const errors = this.validateTicket();
    const hasErrors = this.hasErrors(errors);

    if (hasErrors) {
      this.setState({
        errors: errors,
      });
    } else {
      this.setState({
        comment: "",
        reply: false,
        errors: {},
      });
      this.props.supportActions.submitZendeskComment(
        this.state.comment,
        this.props.ticket.ticketId
      );
    }
  };

  render() {
    if (!this.props.ticket) {
      return <Loading />;
    }

    const comments = this.props.ticket.publicComments;

    return (
      <Page permission={Permissions.fleet.node.any}>
        <Page.Header
          title={`#${this.props.ticket.ticketId} - ${this.props.ticket.subject}`}
          actions={this.props.ticket.address}
        >
          <Page.Header.Actions>
            {this.props.ticket.status !== "closed" && this.props.ticket.status !== "solved" ? (
              <Button
                id="support-issue-comment-new"
                type="primary"
                icon="plus"
                onClick={this.addComment}
              >
                Add Reply
              </Button>
            ) : null}
          </Page.Header.Actions>
        </Page.Header>
        <Page.Content>
          <SupportIssueInfo ticket={this.props.ticket} />
          <div className="comment-thread">
            {this.state.reply ? (
              <CommentAdd
                handleFieldOnChange={this.handleFieldOnChange}
                comment={this.state.comment}
                cancelComment={this.handleOpenModal}
                submitComment={this.submitComment}
                errors={this.state.errors}
              />
            ) : null}
            <CommentList data={comments} history={this.props.history} />
          </div>
          {this.state.showCancelModal ? (
            <Modal className="support-issues-modal">
              Are you sure you want to delete your comment?
              <div className="button-row-container">
                <Button
                  id="support-issue-comment-cancel-modal"
                  type="secondary"
                  icon="times"
                  onClick={this.handleCloseModal}
                >
                  Cancel
                </Button>
                <Button
                  id="support-issue-comment-delete-comment"
                  type="primary"
                  onClick={this.deleteComment}
                >
                  Delete
                </Button>
              </div>
            </Modal>
          ) : null}
        </Page.Content>
      </Page>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SupportIssue);
